import PropTypes from 'prop-types';
import React from 'react';

export class ZeroState extends React.Component {
  renderZeroStateHeader() {
    return (
      <div className="zero-state-header">
          { this.props.onButtonClick ?
            <button
              type="button"
              className="btn btn-link icon-only visible-xs-inline visible-sm-inline"
              data-toggle="modal" data-target="#newMessage"
              onClick={ this.props.onButtonClick }
            >
                <span className="glyphicon glyphicon-edit"></span>
            </button>
                : null}
      </div>
    );
  }

  render() {
    return (
       <div className="row">
         <div className="col-xs-12">
          { this.props.showZeroHeader ? this.renderZeroStateHeader() : null }
          <div className="custom-list-wrapper">
            <div className="zero-state-container">
            <div className="zero-state-content">
            <span
              className={ 'fa fa-5x ' + (this.props.stateIconCss ? this.props.stateIconCss : '') }
            >
            </span>
            <span tabIndex="0">{ this.props.zeroStateMessage }</span>
            </div>
            </div>
          </div>
         </div>
       </div>
    );
  }
}

ZeroState.propTypes = {
  zeroStateMessage: PropTypes.object,
  stateIconCss: PropTypes.string,
  onButtonClick: PropTypes.func,
  showZeroHeader: PropTypes.bool,
};

ZeroState.defaultProps = {
  showZeroHeader: true,
};
